import { tget, tpost } from '../../utils/Utils/Utils';

export function actionGoalFetchAll() {
  return (dispatch) => {
    tget('/api/v3/torga/goal').then((result) => {
      dispatch({ type: 'GOAL_FETCH_ALL_COMPLETE', payload: result });
    });
  };
}

export function actionGoalCreate(name, activityID, callback = null) {
  return (dispatch) => {
    tpost('/api/v3/torga/goal', {
      name,
      ...(activityID ? { activity_id: Number(activityID) } : {}),
    }).then((result) => {
      dispatch({ type: 'GOAL_CREATE_COMPLETE', payload: [result] });
      callback && callback(result);
    });
  };
}

export function actionGoalUpdate(id, field, value) {
  return (dispatch) =>
    tpost(`/api/v3/torga/goal/${id}`, { [field]: value }).then((result) => {
      dispatch({ type: 'GOAL_UPDATE_COMPLETE', payload: [result] });
    });
}

export function actionGoalDelete(id) {
  return actionGoalUpdate(id, 'deleted', true);
}

export function actionGoalTaskFetchAll() {
  return (dispatch) => {
    tget('/api/v3/torga/goaltask').then((result) => {
      dispatch({ type: 'GOALTASK_FETCH_ALL_COMPLETE', payload: result });
    });
  };
}

export function actionGoalSetActivity(goalID, activityID, deleted = false) {
  return (dispatch) => {
    tpost('/api/v3/torga/activitygoal', {
      goal_id: goalID,
      activity_id: activityID,
      deleted,
    }).then((result) => {
      dispatch({ type: 'ACTIVITYGOAL_UPDATE_COMPLETE', payload: [result] });
    });
  };
}

export function actionGoalAddToActivity(goalID, activityID) {
  return actionGoalSetActivity(goalID, activityID, false);
}

export function actionGoalRemoveFromActivity(goalID, activityID) {
  return actionGoalSetActivity(goalID, activityID, true);
}
